export const ProfileRoute = {
  Profile: (): string => '/profile',
  Wallet: (): string => '/wallet',
  WalletApprove: (): string => '/wallet/approve',
  OrdersHistory: (): string => '/dashboard/orders/history',
  WalletChange: (): string => '/profile/wallet/change',
};
